import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { Button, Modal, message } from "antd";
import { unassignTask } from '../../webServices/Apis';

const UnassignTask = ({ showUnassignTask, setShowUnassignTask, selectedProject, action, setAction }) => {
    const [open, setOpen] = useState(showUnassignTask)
    const [loading, setLoading] = useState(false)
    const [tasks, setTasks] = useState(selectedProject.taskList || [])


    const handleRemoveTask = async (id) => {
        try {
            setLoading(true)

            const response = await unassignTask(id)
            if (response?.data?.success) {
                message.success(response?.data?.message)
                setOpen(false)
                setAction(!action)
                setShowUnassignTask(false)
            }

        } catch (error) {
            console.log("Error while unassign task", error.message)
            message.error(error?.response?.data?.message || "Error while unassign task")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && (
                <Loader />
            )}
            <Modal
                className="scrollbar-hidden"
                title="Assigned Tasks"
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setShowUnassignTask(!showUnassignTask);
                    setTasks([...selectedProject.taskList])
                }}
                footer={[
                    <Button key="cancel"
                        className="border border-gray-800 bg-gray-300 px-8 py-4 mt-4"
                        onClick={() => {
                            setOpen(false);
                            setShowUnassignTask(!showUnassignTask);
                            setTasks([...selectedProject.taskList])
                            // setAction(!action)
                        }}>
                        Cancel
                    </Button>
                ]}
                centered
                style={{
                    maxHeight: "700px",

                    overflowY: "scroll"
                }}
            >
                <form className="space-y-4">
                    {/* Dynamic Task Fields */}
                    {tasks?.length > 0 &&
                        tasks?.map((taskItem, index) => (
                            <div className="mb-4 mt-4" key={index}>
                                <label className="block mb-1">Task {index + 1}:</label>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        name="task"
                                        className="border border-gray-800 p-2 w-full"
                                        value={taskItem.taskName}
                                    // onChange={(e) => handleChange(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="taskBudget"
                                        className="border border-gray-800 p-2 w-full"
                                        value={taskItem.taskBudget}
                                    // onChange={(e) => handleChange(index, e)}
                                    />
                                
                                        {!taskItem.isInvoiceRaised && (
                                        <Button
                                            type="danger"
                                            onClick={() => handleRemoveTask(taskItem.taskId)}
                                            className="ml-2 border-gray-800 hover:bg-red-300"
                                        >
                                            Unassign
                                        </Button>

                                    )}

                                </div>
                            </div>
                        ))}
                </form>
            </Modal>


        </>
    )
}

export default UnassignTask